import { useCallback, useContext, useState, DependencyList } from 'react'
import axiosUtils from 'utils/api/axiosUtils'
import axios from 'utils/api/axios'
import { HttpStatusCode } from 'axios'
import { Message, MessageSeverity } from 'constants/message'
import i18n from '../../i18n'
import MessageContext from 'context/MessageContext'
import AuthContext from 'context/AuthContext'
import LoadingContext from 'context/LoadingContext'

function useQuery<T>(url: string, deps: DependencyList = []) {
  const [error, setError] = useState<Error | null>(null)
  const { handleDisplayMessage } = useContext(MessageContext)
  const { setIsConnected, handleRequestLogin, setModalLogInOpened } = useContext(AuthContext)
  const { handleLoadInProgress, isLoading } = useContext(LoadingContext)

  const fetchData = useCallback(async (params?: Record<string, string | number | null>) => {
    handleLoadInProgress(true)
    setError(null)
    try {
      const headerCompleted = await axiosUtils.getHeader(axiosUtils.HEADERS.HEADER_READ)
      console.debug(
        'Root-component <App> :: called URL = ' +
          axios.getUri({
            url,
            params: params,
          }),
      )
      return await axios.get<T>(url, {
        headers: headerCompleted,
        withCredentials: false,
        params,
      })
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)))

      console.log({ err })

      // TODO EHA : define a custom error
      // TODO EHA : move forbidden to response interceptor
      if (err.response?.status === HttpStatusCode.Unauthorized) {
        handleDisplayMessage(new Message(MessageSeverity.WARNING, '', null, i18n.t('sessionExpired')))
        setIsConnected(false)
        setModalLogInOpened(true)
        handleRequestLogin()
      } else if (err.response?.status === HttpStatusCode.Forbidden) {
        handleDisplayMessage(new Message(MessageSeverity.ERROR, '', null, i18n.t('9500138')))
      } else if (err.response?.status === HttpStatusCode.NotFound) {
        handleDisplayMessage(new Message(MessageSeverity.ERROR, '', null, i18n.t('9500173')))
      } else {
        handleDisplayMessage(
          new Message(
            MessageSeverity.ERROR,
            '',
            err.response.data?.amasisCode,
            err.response.data?.description ||
              err.response.data?.title ||
              err.response.data?.message ||
              err.response.data?.error,
          ),
        )
      }
    } finally {
      handleLoadInProgress(false)
    }
  }, deps)

  return { error, fetchData, loading: isLoading }
}

export default useQuery
